import get from 'lodash/get'
import {auth} from 'configs/firebase'

export const getCurrentUser = () => auth.currentUser

export const getCurrentUserId = () => get(getCurrentUser(), 'uid', null)

export const getIdToken = async () => {
  const currentUser = getCurrentUser()

  if (!currentUser) return null

  let idToken = null
  try {
    idToken = await currentUser.getIdToken()
  } catch (err) {
    // log errors??
  }
  return idToken
}
